import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Axios from "../../../Axios";
import { Carousel, Slide } from "../../../ui/Carousel/Carousel";
import "./homeNews.scss";
import { GoArrowLeft, GoArrowRight } from "react-icons/go";

const noIMG = require("../../../assets/no-image.png");

const stripHtml = (html = "") => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return date;
  const yyyy = d.getFullYear();
  const mm = `${d.getMonth() + 1}`.padStart(2, "0");
  const dd = `${d.getDate()}`.padStart(2, "0");
  return `${yyyy}.${mm}.${dd}`;
};

const HomeNews = () => {
  const [data, setData] = useState([]);
  const carouselRef = useRef();

  useEffect(() => {
    Axios.get("/news/list").then((res) => {
      if (res.status === 200 && Array.isArray(res.data)) {
        setData(res.data.slice(0, 9));
      }
    });
  }, []);

  const handleNext = () => {
    carouselRef.current?.next?.();
  };

  const handlePrev = () => {
    carouselRef.current?.prev?.();
  };

  return (
    <section className="homeNews">
      <div className="homeNews__inner">
        <div className="homeNews__header">
          <h3>Мэдээ Мэдээлэл</h3>
        </div>

        <div className="homeNews__carouselWrap">
          <button
            type="button"
            className="homeNews__nav homeNews__nav--left"
            onClick={handlePrev}
            aria-label="Previous"
          >
            <GoArrowLeft />
          </button>

          <button
            type="button"
            className="homeNews__nav homeNews__nav--right"
            onClick={handleNext}
            aria-label="Next"
          >
            <GoArrowRight />
          </button>

          <Carousel
            ref={carouselRef}
            spaceBetween={0}
            slideCount={3}
            autoplaySpeed={5000}
            autoplay
            infinite
            hiddenArrows
          >
            {Array.isArray(data) &&
              data.map((item, idx) => {
                const plainText = stripHtml(item?.content || "");
                const shortText =
                  plainText.length > 120
                    ? `${plainText.substring(0, 120)}...`
                    : plainText;

                return (
                  <Slide key={item?.id || idx} spaceBetween={16}>
                    <div className="homeNews__slide">
                      <Link to={`/news/${item.id}`} className="homeNews__card">
                        <div className="homeNews__imageWrap">
                          <img
                            src={item?.cover || noIMG}
                            alt={item?.title || "news"}
                            className="homeNews__image"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = noIMG;
                            }}
                          />
                        </div>

                        <div className="homeNews__body">
                          <div className="homeNews__meta">
                            <span className="homeNews__badge">
                              {item?.category_name ||
                                item?.category ||
                                "Сургалт"}
                            </span>
                            <span className="homeNews__author">
                              Нийтэлсэн: {item?.author || "Admin"}
                            </span>
                          </div>

                          <h4 className="homeNews__title">
                            {item?.title || "Мэдээний гарчиг"}
                          </h4>

                          <p className="homeNews__desc">
                            {shortText ||
                              "Чанартай, орчин үеийн, ойлгомжтой бүтэцтэй сургалтаар мэдлэгээ дараагийн түвшинд гаргаарай."}
                          </p>

                          <div className="homeNews__footer">
                            <span className="homeNews__action">
                              Дэлгэрэнгүй үзэх
                            </span>
                            <span className="homeNews__date">
                              {formatDate(
                                item?.created_at ||
                                  item?.createdAt ||
                                  item?.date ||
                                  item?.regdate,
                              ) || "2026.06.04"}
                            </span>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </Slide>
                );
              })}
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default HomeNews;
